function initPricingBoxes() {
    const pricingBoxes = document.querySelectorAll('.pricing-boxes-updated');

    pricingBoxes.forEach(section => {
        // Handle individual feature toggles (only actual buttons, not divs)
        const featureToggles = section.querySelectorAll('button.feature-toggle');

        featureToggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                const content = toggle.nextElementSibling;

                toggle.setAttribute('aria-expanded', !isExpanded);

                if (content && content.classList.contains('feature-content')) {
                    content.hidden = isExpanded;
                }

                updateExpandAllButton(toggle.closest('.features-box'));
            });
        });

        // Handle expand all buttons
        const expandAllBtns = section.querySelectorAll('.expand-all-btn');

        expandAllBtns.forEach(btn => {
            const featuresBox = btn.closest('.features-box');
            const expandableToggles = featuresBox.querySelectorAll('button.feature-toggle');

            // Hide expand button if no expandable items in this section
            if (expandableToggles.length === 0) {
                btn.style.display = 'none';
                return;
            }

            btn.addEventListener('click', () => {
                const isCurrentlyExpanded = btn.classList.contains('is-expanded');

                expandableToggles.forEach(toggle => {
                    const content = toggle.nextElementSibling;
                    toggle.setAttribute('aria-expanded', !isCurrentlyExpanded);

                    if (content && content.classList.contains('feature-content')) {
                        content.hidden = isCurrentlyExpanded;
                    }
                });

                btn.classList.toggle('is-expanded');
                btn.textContent = isCurrentlyExpanded ? 'Expand all' : 'Collapse all';
            });
        });
    });

    equalizePricingHeights();
}

function updateExpandAllButton(featuresBox) {
    if (!featuresBox) return;

    const btn = featuresBox.querySelector('.expand-all-btn');
    const toggles = featuresBox.querySelectorAll('button.feature-toggle');

    if (!btn || toggles.length === 0) return;

    const allExpanded = Array.from(toggles).every(
        toggle => toggle.getAttribute('aria-expanded') === 'true'
    );

    btn.classList.toggle('is-expanded', allExpanded);
    btn.textContent = allExpanded ? 'Collapse all' : 'Expand all';
}

function equalizePricingHeights() {
    const pricingBoxes = document.querySelectorAll('.pricing-boxes-updated');

    pricingBoxes.forEach(section => {
        const topBoxes = section.querySelectorAll('.price-box-top');
        const preambles = section.querySelectorAll('.preamble');
        const textContents = section.querySelectorAll('.text-content');

        topBoxes.forEach(el => el.style.minHeight = 'auto');
        preambles.forEach(el => el.style.minHeight = 'auto');
        textContents.forEach(el => el.style.minHeight = 'auto');

        const isLargeScreen = window.matchMedia('(min-width: 1024px)').matches;

        if (isLargeScreen) {
            if (topBoxes.length > 1) {
                let maxHeight = 0;
                topBoxes.forEach(el => {
                    maxHeight = Math.max(maxHeight, el.offsetHeight);
                });
                topBoxes.forEach(el => el.style.minHeight = maxHeight + 'px');
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', initPricingBoxes);

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(equalizePricingHeights, 250);
});